import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { BasicInfoComponentsComponent } from 'libs/shared/ui-common/src/lib/components/basic-info-components/basic-info-components.component';

@Component({
  standalone: true,
  imports: [FormsModule, TranslocoModule, BasicInfoComponentsComponent],
  selector: 'sidebar-technical-info',
  templateUrl: './technical-info.component.html',
  styleUrls: ['./technical-info.component.scss'],
})
export class TechnicalInfoComponent {
  @Input() guidelineComponent;
  @Input() label;
}
